import { Box, Grid, Typography } from "@mui/material";

interface PresentationCompositionProps {
  presentation: any;
}

export default function PresentationComposition({ presentation }: PresentationCompositionProps) {
  if (!presentation.participants || presentation.participants.length === 0) {
    return null;
  }

  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          color: "#2f2f2f",
          mb: 1,
        }}
      >
        Skład ({presentation.participants.length} osób):
      </Typography>
      <Grid container spacing={1}>
        {presentation.participants
          .sort((a: any, b: any) =>
            a.lastName.localeCompare(b.lastName, "pl", {
              sensitivity: "base",
            })
          )
          .map((participant: any, pIndex: number) => (
            <Grid item xs={12} sm={6} md={4} lg={2} key={pIndex}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "0.85rem",
                  color: "#2f2f2f",
                }}
              >
                {participant.firstName} {participant.lastName}
                {participant.birthDate && (
                  <span
                    style={{
                      color: "#6c6c6c",
                      marginLeft: 4,
                      fontSize: "0.8rem",
                    }}
                  >
                    ({new Date(participant.birthDate).getFullYear()})
                  </span>
                )}
              </Typography>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
}
